import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Terrazzo from "./components/Terrazzo";
import styles from "./AuthLayout.module.css";

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div>
      <Nav />
      <main className={styles.split}>
        <aside className={styles.brand}>
          <Terrazzo className={styles.brandBg} />
          <div className={styles.brandInner}>
            <span className={styles.dot} aria-hidden="true" />
            <h2 className={styles.brandTitle}>Urban Services</h2>
            <p className={styles.brandTag}>The care your home deserves.</p>
          </div>
        </aside>
        <section className={styles.panel}>
          <div className={styles.card}>
            <h1 className={styles.title}>{title}</h1>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            {children}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
